/**
 * Namespaced storage for Fasto Ads. Kept intentionally small: the portal only
 * needs the refresh token, the auth mode (advertiser vs team) and a theme.
 */
const BASE_NS = 'fasto-ads:v1';
const REFRESH_KEY = `${BASE_NS}:refresh`;
const MODE_KEY = `${BASE_NS}:mode`;
const THEME_KEY = `${BASE_NS}:theme`;

export type AuthMode = 'advertiser' | 'team';

export const storage = {
  getRefresh(): string | null {
    try {
      return localStorage.getItem(REFRESH_KEY);
    } catch {
      return null;
    }
  },
  setRefresh(token: string | null) {
    try {
      if (token) localStorage.setItem(REFRESH_KEY, token);
      else localStorage.removeItem(REFRESH_KEY);
    } catch {
      /* private mode */
    }
  },
  getMode(): AuthMode {
    try {
      const v = localStorage.getItem(MODE_KEY);
      return v === 'team' ? 'team' : 'advertiser';
    } catch {
      return 'advertiser';
    }
  },
  setMode(mode: AuthMode | null) {
    try {
      if (mode) localStorage.setItem(MODE_KEY, mode);
      else localStorage.removeItem(MODE_KEY);
    } catch {
      /* noop */
    }
  },
  getTheme(): 'light' | 'dark' {
    try {
      const v = localStorage.getItem(THEME_KEY);
      return v === 'dark' ? 'dark' : 'light';
    } catch {
      return 'light';
    }
  },
  setTheme(theme: 'light' | 'dark') {
    try {
      localStorage.setItem(THEME_KEY, theme);
    } catch {
      /* noop */
    }
  },
  clearAuth() {
    this.setRefresh(null);
    this.setMode(null);
  },
};
